import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['template', 'contactsContainer', 'contact', 'scrollContainer'];

  connect() {
    this.index = 0;
    this.reindex()
  }

  add() {
    const content = this.templateTarget.innerHTML.replace(
      /__INDEX__/g,
      `Contact ${this.index + 1}`,
    );
    const wrapper = document.createElement('div');
    wrapper.innerHTML = content;

    this.contactsContainerTarget.appendChild(wrapper);
    this.index++;

    this.scrollContainerTarget.classList.remove('hidden');

    this.cleanupDividers();
  }

  remove(event) {
    const contactElement = event.target.closest("[data-billing-contacts-target='contact']");
    contactElement.remove();
    this.reindex();

    const count = this.contactsContainerTarget.querySelectorAll(
      "[data-billing-contacts-target='contact']",
    ).length;

    if (count === 0) {
      this.scrollContainerTarget.classList.add('hidden');
    }

    this.cleanupDividers();
  }

  reindex() {
    this.index = 0;
    this.contactsContainerTarget
      .querySelectorAll("[data-billing-contacts-target='contact']")
      .forEach((el) => {
        const header = el.querySelector('h4');
        if (header) {
          header.textContent = `Contact ${this.index + 1}`;
        }
        this.index++;
      });
  }

  cleanupDividers() {
    const contacts = this.contactsContainerTarget.querySelectorAll(
      "[data-billing-contacts-target='contact']",
    );

    this.contactsContainerTarget
      .querySelectorAll('.contact-divider')
      .forEach((divider) => divider.remove());

    contacts.forEach((contact, idx) => {
      if (idx > 0) {
        const divider = document.createElement('div');
        divider.className = 'w-full h-px bg-black-100 contact-divider';
        contact.before(divider);
      }
    });
  }
}
